// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VideoCard_video-card__Rgdlb {
  border-radius: 5px;
  height: fit-content;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
  margin: 5px;
  overflow-y: hidden;
}
.VideoCard_video-card__Rgdlb .VideoCard_video-loader__htIQf {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.VideoCard_video-card__Rgdlb .VideoCard_video-loader__htIQf .ant-skeleton {
  width: 100%;
  height: 100%;
}
.VideoCard_video-card__Rgdlb .VideoCard_video-loader__htIQf .ant-skeleton .ant-skeleton-input {
  width: 100%;
  height: 100%;
}
.VideoCard_video-card__Rgdlb .VideoCard_title__JiBOV {
  margin-bottom: 10px !important;
  color: var(--explore-color);
  font-weight: 500;
  cursor: pointer;
}
.VideoCard_video-card__Rgdlb .VideoCard_title__JiBOV:hover {
  text-decoration: underline;
  font-weight: 700;
}
.VideoCard_video-card__Rgdlb .VideoCard_description__UnWpv {
  margin-bottom: 10px;
}
.VideoCard_video-card__Rgdlb .VideoCard_description__UnWpv p {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/Explore/Components/VideoCarousel/VideoCard.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;AACF;AAAE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAEJ;AADI;EACE,WAAA;EACA,YAAA;AAGN;AAFM;EACE,WAAA;EACA,YAAA;AAIR;AAAE;EACE,8BAAA;EACA,2BAAA;EACA,gBAAA;EACA,eAAA;AAEJ;AADI;EACE,0BAAA;EACA,gBAAA;AAGN;AAAE;EACE,mBAAA;AAEJ;AADI;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AAGN","sourcesContent":[".video-card {\n  border-radius: 5px;\n  height: fit-content;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  position: relative;\n  margin: 5px;\n  overflow-y: hidden;\n  .video-loader {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    :global(.ant-skeleton) {\n      width: 100%;\n      height: 100%;\n      :global(.ant-skeleton-input) {\n        width: 100%;\n        height: 100%;\n      }\n    }\n  }\n  .title {\n    margin-bottom: 10px !important;\n    color: var(--explore-color);\n    font-weight: 500;\n    cursor: pointer;\n    &:hover {\n      text-decoration: underline;\n      font-weight: 700;\n    }\n  }\n  .description {\n    margin-bottom: 10px;\n    p {\n      display: -webkit-box;\n      -webkit-line-clamp: 3;\n      -webkit-box-orient: vertical;\n      overflow: hidden;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"video-card": `VideoCard_video-card__Rgdlb`,
	"video-loader": `VideoCard_video-loader__htIQf`,
	"title": `VideoCard_title__JiBOV`,
	"description": `VideoCard_description__UnWpv`
};
export default ___CSS_LOADER_EXPORT___;
